import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { Messages } from 'src/ui/components/Messages';
import { Notifications } from 'src/ui/components/Notifications';
import { CreateApiTokenDialog } from 'src/ui/containers/dialogs/CreateApiTokenDialog';
import { CreateProfileDialog } from 'src/ui/containers/dialogs/CreateProfile/CreateProfileDialog';
import { CreateVoiceboxAppDialog } from 'src/ui/containers/dialogs/CreateVoiceboxAppDialog';
import { DeleteAccountDialog } from 'src/ui/containers/dialogs/DeleteAccountDialog';
import { UnsupportedBrowserDialog } from 'src/ui/containers/dialogs/UnsupportedBrowserDialog';
import { UpdateProfileDialog } from 'src/ui/containers/dialogs/UpdateProfile/UpdateProfileDialog';
import { UpdateVoiceboxAppDialog } from 'src/ui/containers/dialogs/UpdateVoiceboxAppDialog';
import { VerifyEmailDialog } from 'src/ui/containers/dialogs/VerifyEmailDialog';
import { AddEndpointDialog } from 'src/ui/containers/endpoints/dialogs/AddEndpointDialog';
import { AddMyOrgEndpointDialog } from 'src/ui/containers/endpoints/dialogs/AddMyOrgEndpointDialog';
import { CancelEndpointDialog } from 'src/ui/containers/endpoints/dialogs/CancelEndpointDialog';
import { DeleteEndpointDialog } from 'src/ui/containers/endpoints/dialogs/DeleteEndpointDialog';
import { DeleteMyOrgEndpointDialog } from 'src/ui/containers/endpoints/dialogs/DeleteMyOrgEndpointDialog';
import { EditEndpointDialog } from 'src/ui/containers/endpoints/dialogs/EditEndpointDialog';
import { EditMyOrgEndpointDialog } from 'src/ui/containers/endpoints/dialogs/EditMyOrgEndpointDialog';
import { EditSharedEndpointDialog } from 'src/ui/containers/endpoints/dialogs/EditSharedEndpointDialog';
import { EditSharedOrganizationEndpointDialog } from 'src/ui/containers/endpoints/dialogs/EditSharedOrganizationEndpointDialog';
import { RenameMySharedEndpointDialog } from 'src/ui/containers/endpoints/dialogs/RenameMySharedEndpointDialog';
import { ShareEndpointDialog } from 'src/ui/containers/endpoints/dialogs/ShareEndpointDialog';
import { ShareOrganizationEndpointDialog } from 'src/ui/containers/endpoints/dialogs/ShareOrganizationEndpointDialog';
import { SignInDialog } from 'src/ui/containers/endpoints/dialogs/SignInDialog';
import { VoiceboxResponseReportDialog } from 'src/ui/containers/endpoints/dialogs/VoiceboxResponseReportDialog';
import { AddOrganizationDialog } from 'src/ui/containers/organization/dialogs/AddOrganizationDialog';
import { ConfigureOrgSSODialog } from 'src/ui/containers/organization/dialogs/ConfigureOrgSSODialog';
import { DeleteOrganizationDialog } from 'src/ui/containers/organization/dialogs/DeleteOrganizationDialog';
import { EditOrganizationDialog } from 'src/ui/containers/organization/dialogs/EditOrganizationDialog';
import { InviteOrganizationMembersDialog } from 'src/ui/containers/organization/dialogs/InviteOrganizationMembersDialog';
import { LeaveOrganizationDialog } from 'src/ui/containers/organization/dialogs/LeaveOrganizationDialog';
import { TransferOrganizationDialog } from 'src/ui/containers/organization/dialogs/TransferOrganizationDialog';
import { PartnerConnectionDialog } from 'src/ui/containers/partner/databricks/PartnerConnectionDialog';
import { Voicebox } from 'src/ui/containers/voicebox/Voicebox';
import { VoiceboxContextWrapper } from 'src/ui/containers/voicebox/VoiceboxContextWrapper';

export const AppDialogs: React.VFC = () => {
  return (
    <>
      <Notifications />
      <Messages />
      <UnsupportedBrowserDialog />
      <CreateProfileDialog />
      <UpdateProfileDialog />
      <DeleteAccountDialog />
      <PartnerConnectionDialog />
      <VerifyEmailDialog />
      <Switch>
        <Route
          path={[
            '/o/:org([a-z0-9-]+)/connections/:id(\\d+)',
            '/o/:org([a-z0-9-]+)/',
            '/connections/:id(\\d+)',
            '/u/:id(\\d+)',
            '*',
          ]}
        >
          <AddEndpointDialog />
          <SignInDialog />
          <EditEndpointDialog />
          <DeleteEndpointDialog />
          <CancelEndpointDialog />
          <AddMyOrgEndpointDialog />
          <EditMyOrgEndpointDialog />
          <DeleteMyOrgEndpointDialog />
          <ShareOrganizationEndpointDialog />
          <EditSharedOrganizationEndpointDialog />
          <RenameMySharedEndpointDialog />
          <ShareEndpointDialog />
          <EditSharedEndpointDialog />
          <AddOrganizationDialog />
          <ConfigureOrgSSODialog />
          <DeleteOrganizationDialog />
          <EditOrganizationDialog />
          <InviteOrganizationMembersDialog />
          <LeaveOrganizationDialog />
          <TransferOrganizationDialog />
        </Route>
      </Switch>
      <CreateApiTokenDialog />
      <UpdateVoiceboxAppDialog />
      <CreateVoiceboxAppDialog />
      <VoiceboxResponseReportDialog />
      <VoiceboxContextWrapper>
        <Voicebox />
      </VoiceboxContextWrapper>
    </>
  );
};
